import React from "react";
import StarRatings from "react-star-ratings";
import { FaCircleCheck } from "react-icons/fa6";
import { FaCircleXmark } from "react-icons/fa6";
import { FaGooglePlay } from "react-icons/fa6";
import { FaApple } from "react-icons/fa6";
import "./NammaDriverTable.css"



function NammaDriverTable() {
  return (
    <div className="CallDriversTable_MainDiv">
      <div className="CallDriversTable_Heading">Weigh your options</div>
      <div className="CallDriversTable_SubHeading">
        Both DriveU and NammaDriver offer professional car driver service. But,
        which service would you choose for safe and reliable rides after looking
        at this comparison? See where the two services stand based on pricing,
        popularity of the apps, insurance, safety features, packages and
        coverage.
      </div>
      <div className="updateData">Last Updated: 06 May 2024</div>
      <div style={{ width: "100%" }} className="CallDrivers_Table">
        <table style={{ borderRadius: "80px" }}>
          <thead className="CallDrivers_TableHead">
            <tr>
              <th
                className="CallDrivers_maxFont"
                style={{ borderTopLeftRadius: "40px" }}
              >
                ATTRIBUTE
              </th>
              <th className="CallDrivers_maxFont">DRIVEU</th>
              <th
                className="CallDrivers_maxFont"
                style={{ borderTopRightRadius: "40px" }}
              >
                NammaDriver
              </th>
            </tr>
          </thead>
          <tbody className="CallDrivers_TableBody">
            {/* first Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Weekend Charges
              </td>
              <td>
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* second Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Prorated Charges
              </td>
              <td className="CallDrivers_smallFont">
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
                <br />
                (by the min)
              </td>
              <td className="CallDrivers_mediumFont">
                {/* <img
                  className="Table_Img"
                  src="https://ik.imagekit.io/driveu/Web/Group_2046_e9i_tWVgP.png"
                   alt="DriveU"
                />
                <br />
                (by the min) */}
                NA
              </td>
            </tr>
            {/* third */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">App</td>
              <td className="CallDrivers_smallFont">
                {/* <img
                  className="CallDrive_Table_PndAImg_rating"
                  src="https://ik.imagekit.io/driveu/Web/Group_2050_klmp2If5M.png"
                  alt="DriveU"
                /> */}
                <FaGooglePlay style={{ fontSize: "19px", color: "black" }} />
                <FaApple style={{ fontSize: "22px", color: "black" }} />
              </td>
              <td className="CallDrivers_smallFont">
                {/* <img
                  className="CallDrivers_Table_Img"
                  src="https://ik.imagekit.io/driveu/Web/_x34_kIJNq_1__BJpn6LJrc.png"
                  alt="DriveU"
                /> */}
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* fourth */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">Installs</td>
              <td className="CallDrivers_mediumFont">1M+</td>
              <td className="CallDrivers_mediumFont">
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* fifth */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Play store rating
              </td>
              <td className="CallDrivers_smallFont">
                <StarRatings
                  rating={4}
                  numberOfStars={4}
                  starRatedColor="black"
                  starDimension="15px"
                  starSpacing="0"
                />
                <br />
                (12.3K reviews)
              </td>
              <td className="CallDrivers_smallFont">
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* first Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Trip Secure Plan
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* second Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Driver tracking
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* third */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Driver training
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
            </tr>
            {/* fourth */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Drivers in uniform
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* fifth */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Background verification
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
            </tr>
            {/* first Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Hourly packages
              </td>
              <td>
                <FaCircleCheck style={{ color: "green", fontSize: "21px" }} />
              </td>
              <td>
                <FaCircleXmark style={{ color: "red", fontSize: "21px" }} />
              </td>
            </tr>
            {/* first Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">Cities served</td>
              <td className="CallDrivers_mediumFont">
                Bengaluru, Mumbai, Hyderabad, Chennai, Delhi NCR, Pune,
                Ahmedabad, Coimbatore, Kolkata
              </td>
              <td className="CallDrivers_mediumFont">
                Bengaluru
              </td>
            </tr>
            {/* second Row */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Number of drivers
              </td>
              <td className="CallDrivers_mediumFont">100,000+</td>
              <td className="CallDrivers_mediumFont">10000+</td>
            </tr>
            {/* third */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Customers served
              </td>
              <td className="CallDrivers_mediumFont">750,000+</td>
              <td className="CallDrivers_mediumFont">8,000+</td>
            </tr>
            {/* fourth */}
            <tr>
              <td className="CallDrivers_maxFont rowHeading">
                Bookings completed
              </td>
              <td className="CallDrivers_mediumFont">6M+</td>
              <td className="CallDrivers_mediumFont">NA</td>
            </tr>
            {/* fifth */}
            <tr
              style={{
                border: "solid transparent",
                borderTop: "1px solid rgba(9, 8, 26, 0.1)",
              }}
            >
              <td className="CallDrivers_maxFont rowHeading">
                Operating since
              </td>
              <td className="CallDrivers_mediumFont">2015</td>
              <td className="CallDrivers_mediumFont">2015</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NammaDriverTable;
